import { store } from '@/store/store';
import { form_item } from '@/shared/dtos/dinamically_forms/form_item';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'form_itemModule',
    store,
    dynamic: true
})
class form_itemModule extends VuexModule {
    public form_items: form_item[] = [];
    public form_item: form_item = new form_item();

    @Action({ commit: 'onGetform_items' })
    public async getform_items() {
        return await ssmHttpService.get(API.form_item);
    }

    @Action({ commit: 'onGetform_item' })
    public async getform_item(id: any) {
        return await ssmHttpService.get(API.form_item + '/' + id);
    }

    @Action
    public async guardarform_item(form_item: form_item) {
       return await ssmHttpService.post(API.form_item, form_item.toJson());
    }

    @Action
    public async modificarform_item(form_item: form_item) {
        return await ssmHttpService.put(API.form_item + '/' + form_item.id, form_item);
    }

    @Action
    public async eliminarform_item(form_item: form_item) {
       return await ssmHttpService.delete(API.form_item + '/' + form_item.id, null, false);
    }
    
    @Mutation
    public onGetform_items(res: form_item[]) {
        this.form_items = res ? res.map((x) => new form_item(x)) : []
    }

    @Mutation
    public onGetform_item(res: form_item) {
        this.form_item = new form_item(res);
    }

}
export default getModule(form_itemModule);